<template>
    <auth-layout>
        <Head>
            <title>Passwort vergessen</title>
        </Head>

        <div class="auth-form">
            <div class="auth-form--form">
                <h3>
                    <h3 v-translate>Passwort vergessen?</h3>
                </h3>
                <form @submit.prevent="submit">
                    <form-input type="email" id="email" :label="this.$gettext('Email Adresse')" v-model="form.email"
                                :placeholder="this.$gettext('john@doe.com')" :error="form.errors.email" icon="email-mail-checkmark"
                                autocomplete="email" autofocus/>

                    <div class="form-actions">
                        <form-button type="submit" color="secondary" icon="lock-shield-prote">
                            <translate>Anweisungen zusenden</translate>
                        </form-button>
                    </div>
                </form>
            </div>
            <div class="auth-form--info">
                <p class="body-2 body-2--disabled">
                    <translate>Als geprüfter Produzent können Sie sich mit den von uns übermittelten Anmeldedaten schnell und einfach anmelden.</translate>
                </p>
            </div>
        </div>
    </auth-layout>
</template>

<script>
import AuthLayout from '@partfactory/Layouts/AuthLayout';
import FormInput from '@partfactory/Shared/Form/FormInput';
import {useForm} from '@inertiajs/vue3';
import FormButton from '@partfactory/Shared/Form/FormButton';

export default {
    name: 'ForgotPassword',
    components: {
        FormButton,
        FormInput,
        AuthLayout,
    },
    setup() {
        const form = useForm({
            email: null,
        });

        return {form};
    },
    methods: {
        submit() {
            this.form
                .transform(data => ({
                    ...data,
                    _token: this.$page.props.csrf_token,
                }))
                .post(this.$$route('password.forgot'), {
                    onSuccess: () => {
                        this.form.reset('email');
                    }
                });
        },
    },
};
</script>
